import faqDataEn from "../faq/FAQDataEn";
import faqDataAUEn from "../faq/FAQDataAUEn";

export const English = {
  translation: {
    brandInfo: {
      botName: {
        lifesafer: "Lili",
        monitechiid: "Molly",
        guardianinterlock: "Gabby",
        quickstartaz: "Kelly",
      },
      brandName: {
        lifesafer: "LifeSafer",
        monitechiid: "Monitech",
        guardianinterlock: "Guardian Interlock",
        quickstartaz: "QuickStart",
      },
      brandPhone: {
        lifesafer: "(855) 221-0171", //special phone number for LS installations
        monitechiid: "(800) 521-4246",
        guardianinterlock: "(800) 499-0994",
        quickstartaz: "(888) 717-8278",
        AU: "1800-785-055",
      },
      brandPhoneHref: {
        lifesafer: "tel:+1-855-221-0171",
        monitechiid: "tel:+1-800-521-4246",
        guardianinterlock: "tel:+1-800-499-0994",
        quickstartaz: "tel:+1-888-717-8278",
        AU: "tel:+61-1800-785-055",
      },
    },
    policies: {
      termsofUseLabel: "Terms of Use",
      privacyLabel: "Privacy",
      cookiesLabel: "Cookies",
      qualityLabel: "Quality",
      copyrightLabel: "Copyright",
      callMonitech:
        "Unfortunately we aren't in this state, but good news our partner Monitech does service this state!! Please feel free to reach out to Monitech at (800) 521-4246.",
      countyQuestionable:
        "For this county we will need you to contact us so we can assist you with enrollment, (800) 634-3077.",
    },
    faqs: {
      header: "Frequently Asked Questions",
      button: "View FAQs",
      tipOfTheDay: "Tip of the Day",
      faqData: faqDataEn,
      faqDataAU: faqDataAUEn,
    },
    carousel: {
      name1: "Appointments",
      description1:
        "View, schedule, change, or cancel your service appointments conveniently and quickly.",
      name2: "Payments",
      description2:
        "View, set up, or change your preferred payment method easily and securely keeping you in control of your account.",
      name3: "Device Resources",
      description3:
        "Review, watch, and learn important information about your device so you can understand your journey with LifeSafer.",
      loginText: "Protecting <br> what matters <br> <colored>most.</colored>",
    },
    registration: {
      sectionTitle: "Registration",
      personalInformationStep: "Personal Information",
      addressStep: "Address",
      passwordStep: "Password",
      verify: "Verify",
      continue: "Continue",
      createAccount: "Create Account",
      backToSignIn: "Back to Sign In",
      firstName: "Legal First Name",
      firstNameRequired: "First Name is required.",
      firstNameLengthError: "First name must be two letters or more.",
      lastName: "Legal Last Name",
      lastNameRequired: "Last Name is required.",
      lastNameLengthError: "Last name must be two letters or more.",
      cityRequired: "City is required.",
      cityMinLength: "Min Length is 2.",
      cityInvalid: "City is invalid.",
      emailAddress: "Email Address",
      emailRequired: "Email Address is required.",
      emailValid: "Email Address must be valid.",
      phoneType: "Phone Type",
      cellPhone: "Cell Phone",
      homePhone: "Home Phone",
      phoneNumber: "Phone Number",
      phoneNumberRequired: "Phone number is required",
      homePhoneRequired: "Home Phone is required.",
      phoneValid: "Valid phone number is required.",
      verifyPersonalInformation: "Verify",
      homeAddressLine1: "Address Line 1",
      poHomeAddressPlaceHolder: "Enter your PO Box",
      addressRequired: "Home Address is required.",
      addressDirections:
        "You will need to select an address from the autocomplete.  If your address isn't found, enter your city and state in Address Line 1 and select it from the autocomplete.",
      homeAddressLine2: "Address Line 2",
      homeAddressPlaceHolder: "Enter your home address.",
      homeCityCountyState: "City, County, State",
      homeCityCountyStatePlaceHolder: "This will be filled in for you!",
      homeCity: "City", // not required
      homeCounty: "County", // not required
      homeState: "State", // not required
      stateRequired:
        "State is required. Please enter a valid address or select one from the Address Line 1 dropdown list.",
      stateValid: "State must be valid.", // not required
      homeZip: "Zip",
      ausHomeZip: "Postal Code",
      zipRequired: "Zip Code is required.",
      ausZipRequired: "Postal Code is required.",
      zipValid: "A valid Zip Code must be 5 digits in length.",
      ausZipValid: "A valid Postal Code must be 4 digits in length.",
      continueFromAddress: "Continue",
      password: "Password",
      passwordRequired: "Password is required.",
      passwordPattern:
        "Password must be between 8 - 24 characters in length, contain at least 1 upper case letter, 1 lower case letter, 1 number, and 1 special character.",
      confirmPassword: "Confirm Password",
      confirmPasswordMatch: "The passwords must match.",
      confirmPasswordRequired: "Password Confirmation is required.",
      GoogleText1: "This site is protected by reCAPTCHA and the Google ",
      GoogleText2: " and ",
      GoogleText3: " apply.",
      GoogleLink1: "Privacy Policy",
      GoogleLink2: "Terms of Service",
      emailInUse: "Email already in use",
      emailInUseInstructions:
        "Please enter a different email or reset your password.",
      here: "Here",
      phoneNumberInUse: "Phone number already in use with different email.",
      continueToLogin: "To continue using ",
      returnToLogin: "Return to Login",
      verifyEmail:
        "To use the entered email a text message verification will be sent by clicking ",
      apiErrorTitle: "Error contacting server.",
      apiError:
        "An error occurred while trying to verify your information. Please try again.",
      registrationComplete: [
        "Registration Completed Successfully!",
        "You will be signed in automatically.",
        "If for some reason you are not please return to the Sign In page and log in.",
      ],
      verificationCode: "Verification Code",
      verificationCodeTitle: "Verify phone number",
      verificationCodeDescription:
        "The entered email already exists in our system with a different phone number. To continue using the entered email please verify your phone with the code we have sent via text message.",
      submitVerificationCode: "Submit Code",
      verificationCodeRequired: "Verification Code Required.",
      verificationCodeInvalid: "Verification Code Invalid",
      verificationCodeIncorrect:
        "Verification code was incorrect. Please double check and enter again.",
      verificationCodeExpired: "Verification code expired.",
      dateOfBirth: "Date of Birth",
      dateOfBirthRequired: "Date of Birth Required.",
      dateOfBirthInvalid: "Valid Date of Birth is Required.",
      resetPassword: "Reset Password",
      changeEmail: "Change Email",
      contactUs: "Contact Us",
      contactUsMessage:
        "We do not have a cell phone on record for you. Please call us at (800) 634-3077",
      emailUpdateError: "Error updating email.",
      city: "City",
      client: "Client",
      unAuthorized: "Unauthorized",
      takePhoto: "Take Photo",
      uploadPhoto: "Upload Photo",
      identityVerification: "Identity Verification",
      instructions: "Instructions",
      chooseFile: "Choose File",
      retake: "Retake",
      upload: "Upload",
      newFile: "New File",
      badPhotoFile: "Bad Photo File",
      uploadComplete: "Upload Complete",
      uploadCompleteMessage:
        "Thank you for uploading your State ID which will help ensure accuracy in reporting your data.",
      takePhotoDesp:
        "When taking the picture please ensure the ID is as centered as possible. When you're ready click the button below to activate your camera, you may need to allow us this access (popup should appear).",
      uploadPhotoDesp:
        "When taking the picture please ensure the ID is as centered as possible. Then click the upload button and pick your image. Accepted formats: png, jpg, jpeg, heic.",
      uploadMessage:
        "Note: To ensure your photo is high enough quality for the ID Upload to work please use your mobile device.",
      unAuthorizedMsg:
        "This link has either expired or isn't available for use. If you believe you have reached this message in error please feel free to contact us.",
      honeyPotError: "Something went wrong, please contact us to assist you",
      autoPayEnrollment: "Auto Pay Enrollment",
      autoPayments: "Auto Payments",
      autoPaymentThankYou:
        "Thank you for signing up for Auto Payments, log into your My Account to update if needed.",
      secureSign: "Secure Sign",
      documentSign: "Document Sign",
      signNowThankYou:
        "Thank you for signing your documents, log into your My Account to view any of these signed documents.",
      cellPhoneRequired: "Cell Phone Number is required.",
      cellPhoneValid: "Cell Phone Number must be valid.",
      cellPhoneNumber: "Cell Phone Number",
      noSpace: "First character cannot be a space",
    },
    account: {
      headerSlogan: "We are committed to your success",
      email: "Email Address",
      emailRequired: "Email is required.",
      emailValid: "Invalid email address.",
      password: "Password",
      passwordRequired: "Password is required.",
      passwordForgot: "Forgot Password?",
      signInButton: "Sign In",
      resetPasswordMessage:
        "Once you click the Reset Password button you will then be sent a password reset link to this email address. Please go to your email to complete the final step of the reset.",
      resetPasswordButton: "Next",
      backToSignInButton: "Back to Sign In",
      resetPasswordSent:
        "A password reset link has been sent to this email address. Please go to your email to complete the final step of the reset.",
      resetPasswordSuccess:
        "Please check your email for password reset instructions",
      resetPasswordError:
        "Reset failed, this email is not registered or not confirmed with LifeSafer.",
      resetPhoneError:
        "Reset failed, this phone is not registered or not confirmed with LifeSafer.",
      passwordPattern:
        "Password must be between 8 - 24 characters in length, contain at least 1 upper case letter, 1 lower case letter, 1 number, and 1 special character.",
      confirmPassword: "Confirm Password",
      confirmPasswordRequired: "Password Confirmation is required.",
      confirmPasswordValid: "The passwords must match.",
      resetCode: "Reset Code",
      resetCodeRequired: "Reset Code is required.",
      resetCodeInputInvalid: "Invalid reset code.",
      resetCodeSent:
        "Your reset code has been sent it will expire in 10 minutes",
      resetCodeInvalid: "Invalid reset code, please enter the code again.",
      resetCodeAttempts:
        "Too many invalid reset code attempts. Please start again.",
      resetCodeExpired: "Reset code has expired.",
      resetCodeError: "Reset code failed.",
      tokenFailedPart1:
        "Token validation failed, if the token has expired you can get a new one at the ",
      tokenFailedPart2: "forgot password",
      tokenFailedPart3: " page.",
      tokenValidation: "Validating token...",
      verifyHeader: "Verify Email",
      verificationFailedPart1:
        "Verification failed, you can also verify your account using the ",
      verificationSuccess: "Verification successful, you can now login",
      tokenVerification: "Verifying...",
      registrationSuccess:
        "Registration successful, please check your email for verification instructions.",
      registrationFail:
        "Registration failed, this email is already registered.",
      passwordResetSuccess: "Password reset successful, you can now login.",
      receiveText: "Receive a reset text message",
      receiveEmail: "Receive a reset email",
      idUpload: "ID Upload",
      phoneEmail: "Cell Phone Number or Email",
      phoneEmailRequired: "Cell Phone Number or Email Required.",
      phoneValid: "Invalid Phone Number",
      secureIdUpload: "Secure ID Upload",
      providerChgMessage: "Depending on your provider, text charges may apply.",
    },
    navigation: {
      dashboard: "Dashboard",
      appointments: "Appointments",
      payments: "Payments",
      documents: "Documents",
      resources: "Resources",
      help: "Help",
      logOut: "Log Out",
      language: "Language",
      notifications: "Notifications",
      profile: "Profile",
    },
    buttons: {
      updateButton: "Update",
      nextButton: "Next",
      deleteButton: "Delete",
      createButton: "Create",
      cancelButton: "Cancel",
      closeButton: "Close",
      saveButton: "Save",
    },
    toasts: {
      updateComplete: "Update complete.",
      updateFailed: "Update failed.",
      deleteNotification: "Notification deleted.",
      messageDeleted: "Message deleted.",
      messageUpdated: "Message updated.",
      messageCreated: "Message created.",
      error: "An Error has occurred!",
      uploadComplete: "Upload complete.",
      uploadFailed: "Upload failed.",
      saving: "Saving.",
      updatedSuccesfully: "Updated Successfully",
    },
    home: {
      upcomingAppointments: "Upcoming Appointments",
      noAppointments: "You currently don't have any upcoming appointments.",
      scheduleButton: "Schedule",
      upcomingPayments: "Upcoming Payments",
      paymentPastDue: "Payment Past Due",
      paymentAttentionNeeded: "Attention Needed",
      noPayments: "You currently don't have any upcoming payments.",
      paymentsSignUp:
        "You aren't currently signed up for auto payments. Save time and enroll today.",
      signUpButton: "Sign Up Now!",
      saveTime: "Save Time, Enroll in AutoPay:",
      noNotifications: "You currently don't have any notifications.",
      deviceInfo: "Device Information",
      noDevice: "You currently don't have a LifeSafer device.",
      IID: "Ignition Interlock",
      PAM: "Portable Alcohol Monitor",
      ISA: "Intelligent Speed Assistance",
      serviceLocation: "Service Location:",
      directions: "Directions",
      paymentMethod: "Payment Method:",
      autoPay: "AutoPay:",
      autoPayProcessDate:
        "Your auto payment will process on the date shown above.",
      endingIn: "Ending In:",
      paymentQuote:
        "The amount quoted above is an estimate of your past due balance and a purchase of an additional 14 days.",
      FC100UserGuide:
        "https://www.lifesafer.com/wp-content/uploads/2020/05/2031159-2_A1_BK-LS439-FC100-Camera-Handbook-Master.pdf",
      L250UserGuide:
        "https://www.lifesafer.com/wp-content/uploads/L250-Client-User-Guide.pdf",
      PAMUserGuide:
        "https://www.lifesafer.com/wp-content/uploads/2020/02/LS681.PAM-English-User-Guide.pdf",
      ISAUserGuide: "src/_images/ISA_UserGuide.pdf",
      userGuide: "User Guide",
      tipsAndCare: "Tips & Care",
      training: "Training",
      troubleshooting: "Troubleshooting",
      yesButton: "Yes",
      frequentlyAskedQuestions: "FAQs",
      mobileLocation: "Mobile Location",
      weComeToYou: "We Come to You!",
      isaSummary: "ISA Summary Report",
      staticList1: "Total Trips",
      staticList2: "Total Trip Distance",
      staticList3: "Total Trip Minutes",
      staticList4: "Total Harsh Acceleration",
      staticList5: "Total Hard Braking",
      staticList6: "Total Over Speed",
      staticList7: "Total Overrides",
      ruleListTitle1: "Harsh Acceleration",
      ruleListDescription1:
        "This is when the driver has pressed the accelerator pedal in a more forceful way causing the RPM and speed to increase rapidly. Note, during normal driving conditions a harsh acceleration event can occur even when practicing safe driving habits.",
      ruleListTitle2: "Hard Braking",
      ruleListDescription2:
        "This is when the driver has pressed the brake pedal in a more forceful way causing a sudden decrease in speed. Note, during normal driving conditions a hard brake event can occur even when practicing safe driving habits.",
      ruleListTitle3: "Over Speed",
      ruleListDescription3:
        "This is when the driver has exceeded the standard speed threshold which can occur during overrides, downhill drifting, or tampering. Note, during normal driving conditions an over speed event can occur even when practicing safe driving habits.",

      ruleListTitle4: "Overrides",
      ruleListDescription4:
        "This is when the driver activates the manual override on the touch screen which is typically used to get up to speed more rapidly; uses typically occur on an entry ramp to a highway or to pass another vehicle.",
      distance: "Distance",
      averageTrip: "Average Trip Statistics",
      startDate: "Start Date",
      endDate: "End Date",
      viewReport: "View Report",
      braking: "Braking",
      overspeed: "Overspeed",
      acceleration: "Acceleration",
      selectVehicleError:
        "Please select a vehicle to view your ISA summary report.",
      noDataError: "No data found for the given parameters.",
      invalidDateError: "Please enter valid start and end dates.",
      average:"Average",
      events:"Events",
      eventPerTrip:"Events per Trip",
      startDateRequired:"Start Date is required",
      invalidStartDate:"Invalid Start Date",
      startDateFutureError:"Start date cannot be today or future date",
      endDateRequired:"End Date is required",
      invalidEndDate:"Invalid End Date",
      selectStartDate:"Please select start date first",
      endDateAfterStartDate:"End date must be after start date",
      lessEndDate:"End date must not be greater than today date",
      // startDateFutureError:"Start date cannot be today or future date",

    },
    notifications: {
      typeHeader: "Type",
      messageHeader: "Message",
      dateHeader: "Date",
      deleteButton: "Delete",
      deleteToast: "Notification deleted.",
      updateFailed: "Update failed.",
      messageTooltip: "Unread",
      deleteTooltip: "Delete Notification",
      dashboardButton: "Dashboard",
    },
    profile: {
      personal: "Personal",
      information: " Information",
      personalFull: "Personal Information",
      state: "State",
      id: "ID",
      court: "Court",
      vehicle: "Vehicle",
      name: "Name",
      email: "Email",
      password: "Password",
      lastChanged: "Last Changed: ",
      phone: "Phone",
      cell: "Cell",
      home: "Home",
      emergencyContact: "Emergency Contact",
      preferences: "Preferences",
      contactByText: "Contact By Text",
      contactByEmail: "Contact By Email",
      defaultLanguage: "Language",
      update: "Update",
      firstName: "Legal First Name",
      lastName: "Legal Last Name",
      firstNameRequired: "First Name is required.",
      lastNameRequired: "Last Name is required.",
      currentEmail: "Current Email",
      newEmail: "New Email",
      confirmEmail: "Confirm New Email",
      emailWarning:
        "* Please note by updating your email this will change your login email.",
      newEmailRequired: "New email is required.",
      emailInvalid: "Invalid email address.",
      confirmEmailRequired: "Confirm new email is required.",
      matchEmail: "The email addresses must match.",
      confirmPassword: "Confirm Password",
      passwordWarning:
        "* Your password must be a minimum of 8 characters and contain at least 1 upper case letter, 1 lower case letter, 1 number, and 1 special character.",
      textMessageWarning:
        "Disabling text messages will make it more difficult to log in or reset your password to your My Account site!",
      passwordRequired: "Password is required.",
      passwordValid:
        "Password must be between 8 - 24 characters in length, contain at least 1 upper case letter, 1 lower case letter, 1 number, and 1 special character.",
      confirmPasswordRequired: "Password Confirmation is required.",
      confirmPasswordReq: "Confirm Password is required.",
      matchPassword: "The password must match.",
      cellPhone: "Cell Phone",
      homePhone: "Home Phone",
      homePhoneRequired: "Home Phone is required.",
      phoneValid: "Valid phone number is required.",
      eContactFirstName: "Emergency Contact First Name",
      eContactLastName: "Emergency Contact Last Name",
      eContactPhone: "Emergency Contact Phone",
      eContactFirstNameReq: "Emergency Contact First Name is required.",
      eContactLastNameReq: "Emergency Contact Last Name is required.",
      eContactPhoneRequired: "Emergency Contact Phone is required.",
      eContactPhoneValidation: "Valid Emergency Contact Phone is required.",

      eContactPhoneReq: "Phone number is required.",
      eContactPhoneValid: "Valid phone number is required.",
      mayWeText: "May we contact you by Text Message?",
      mayWeEmail: "May we contact you by Email?",
      languageSelect: "Select a Language",
      languagePrefReq: "Language Preference is required.",
      dob: "Birthday",
      country: "Country",
      address: "Address",
      stateID: "State ID",
      dobLabel: "Date of Birth",
      addrLine1: "Address Line 1",
      addrLine2: "Address Line 2",
      city: "City",
      stateSelect: "Select a State",
      addrLine1Required: "Home Address is required.",
      cityRequired: "City is required.",
      stateRequired: "State is required.",
      idExpirationRequired: "Expiration Date is required.",
      idExpirationInvalid: "Expiration Date is invalid.",
      zip: "Zip",
      zipRequired: "Zip Code is required.",
      zipValid: "A valid Zip Code must be 5 digits in length.",
      zipInvalid: "Zip is Invalid",
      ausZip: "Postal Code",
      ausZipRequired: "Postal Code is required.",
      ausZipInvalid: "Postal Code is invalid.",
      ausZipValid: "A valid Postal Code must be 4 digits in length.",
      IDNumber: "Identification Number",
      expDate: "Expiration Date",
      expDateRequired: "Expiration date is required.",
      countryRequired: "Country is required.",
      IDNumberRequired: "Identification number is required.",
      conviction: "Conviction",
      courtContact: "Court Contact",
      contactEmail: "Contact Email",
      LSDevice: "LifeSafer Device",
      countySelect: "Select County",
      countrySelect: "Select Country",
      VIN: "VIN",
      licensePlate: "License Plate",
      pushStart: "Push Button Start",
      remoteStart: "Remote Start",
      currentVIN: "Current VIN",
      newVIN: "New VIN",
      confirmVIN: "Confirm VIN",
      VINMessagePart1: "* VIN - Vehicle Identification Number",
      VINMessagePart2:
        "A 16 or 17 character identity code that is made of numbers and letters that identifies your vehicle.",
      VINRequired: "VIN is required.",
      VINValid: "VIN must be 16 or 17 characters in length.",
      VINConfirmRequired: "VIN Confirmation is required.",
      VINMatch: "The VINs must match.",
      vehicleConfirm: "Vehicle Confirmation",
      year: "Year: ",
      make: "\nMake: ",
      model: "\nModel: ",
      VINError: "VIN verification was invalid, please retry.",
      currentLP: "Current License Plate: ",
      manualUpdate: "Manual Update",
      newLP: "New License Plate Number",
      confirmLP: "Confirm License Plate Number",
      licensePlateRequired: "License Plate number is required.",
      confirmLPRequired: "Confirm new license plate number is required.",
      licensePlateMatch: "The license plate numbers must match.",
      havePushStart: "Does this vehicle have push start ignition?",
      pushStartMessage:
        "Push start ignition is a keyless button that allows you to start your vehicle while inside the vehicle typically with the brake pedal depressed.",
      haveRemoteStart: "Does this vehicle have remote start ignition?",
      remoteStartMessage:
        "Remote start ignition is a key fob that has a button that allows you to start your vehicle while outside the vehicle by pressing this key fob.",
      updateComplete: "Update complete.",
      passwordUpdateSuccess: "Password update successful.",
      updatePreferencesError: "Cannot update preferences.",
      contactUs:
        "There is a problem updating your profile please contact us so we can assist you.",
      dobRequired: "Date of birth is required.",
      dobUnderage: "Date of Birth Invalid. You must be more than 18.",
      dobInvalid: "Date of Birth is Invalid",
      lName: "Last Name",
      stateCityCountyRequired: "State, City, County is required",
      addressRequired: "{{addressRequired}}",
      chat: "Chat",
      getExpertHelp: "Get Expert Help",
    },
    appointments: {
      appointment: "Appointment",
      scheduleApptButton: "Schedule Appointment",
      scheduleInstButton: "Schedule Installation",
      nextDayMessage:
        "Currently we aren't scheduling same or next day appointments online. If you need a same or next day appointment please",
      within24Message:
        "You are attempting to change an appointment within 24 hours of the appointment, please contact us so we can help you with this request.",
      within4Message:
        "You are attempting to change an appointment within 4 hours of the appointment, please contact us so we can help you with this request.",
      cantChangeMessage:
        "You are attempting to change an installation appointment, please contact us so we can help you with this request.",
      undefinedApptMessage:
        "This appointment cannot be rescheduled from this portal, please contact us so we can help you with this request.",
      reschedule: "Reschedule",
      cancel: "Cancel",
      rescheduleMessage:
        "Keep in compliance, reschedule your appointment online today.",
      contactUsMessage:
        "Let our knowledgeable support team assist you with this appointment.",
      cancelMessagePart1: "Cancel your scheduled appointment.",
      cancelMessagePart2:
        "Cancelling appointments can put you at risk of a compliance violation.",
      keep: "Keep",
      cancelWarning:
        "Please note that cancelling will release this date and time for this location. We can't guarantee this date and time would be available at this location if you did want to reschedule.",
      deviceSelect: "Please Select A Device",
      vehicleSelect: "Please Select A Vehicle",
      lockoutAlertPart1:
        "Attention: Please be aware that it is your responsibility to be serviced prior to your lockout date, your current lockout date is",
      lockoutAlertPart2:
        "If you have any questions, please contact LifeSafer at",
      apptLocContactUsMessage:
        "Please contact us directly to schedule an appointment at this location.",
      apptDeinstallContactUsMessage:
        "Please contact us directly to schedule a Deinstallation Appointment to ensure all state regulations are followed.",
      deinstall: "Deinstall",
      personalInfo: "Personal Information",
      location: "Location",
      service: "Service",
      enterTextBox: "Enter ZIP Code or City, State",
      search: "Search...",
      noLocations: "No locations in the selected area.",
      searchResults: "Search Results",
      select: "Select",
      pastDueService:
        "Your service is past due, let's get you assistance from our 24/7 expert support!",
      almostPastDueService:
        "You need an immediate service to avoid being past due, let's get you assistance from our 24/7 expert support!",
      selectedLocation: "Selected Location",
      selectedService: "Selected Service",
      noAppointmentsAvail:
        "There are currently no available appointments for this location.",
      noTimesAvail:
        "No available appointment times at this location for this date.",
      backToCalendar: "Back to Calendar",
      aptSchedPart1: "You have selected to ",
      aptSchedPart2: " reschedule \n an ",
      aptSchedPart2Alt: "make a \n new ",
      aptSchedPart3: "appointment on: \n",
      aptSchedPart4: " at ",
      aptSchedPart5: "\n for a ",
      aptSchedPart6: " Service \n ",
      aptSchedPart7: "at the following location: \n",
      originalAppt: "Original Appointment Date/Time",
      date: "Date",
      time: "Time",
      cancelSuccess: "Appointment cancelled.",
      cancelFail: "Cancellation failed.",
      apptSaveSuccess: "Appointment saved.",
      apptUpdateSuccess: "Appointment updated.",
      mapInfo: "Map Information",
      sameDayLoc: "Same Day Location",
      standardLoc: "Standard Location",
      installStep1: "What is the enrollment code given to you?",
      installCodeInputLabel: "Enrollment Code",
      installCodeInputRequired: "Enrollment Code is required.",
      installCodeInputInvalid: "Invalid enrollment code.",
      installNoCode: "Don't have an enrollment code? Click ",
      installStateLabel: "State",
      installStatePlaceholder: "Select a State",
      stateRequired: "State is required.",
      cantFindState:
        "Not finding the state your looking for? Please contact our support team to get you in touch with one of our partners that does service your state. Call or Click the button below.",
      installCountyLabel: "County",
      installCountyPlaceholder: "Select a County",
      countyRequired: "County is required.",
      installNotAvailable: [
        "Unfortunately ",
        " doesn't service this state at this time. Please feel free to give us a call if you have questions, ",
        ".",
      ],
      installStep2: [
        "Please, enter in which state you were convicted or are volunteering to have a ",
        " device.",
      ],
      IIDButtonLabel: "Ignition Interlock Device",
      PAMButtonLabel: "Portable Alcohol Monitor",
      ISAButtonLabel: "Intelligent Speed Assistance",
      installStep3Part1: "What type of device do you need? Click ",
      installStep3Part2:
        " for some quick information if you don't know which device you require.",
      installStep3ButtonLabel: "here",
      devicePopupTitle: " Device Information",
      devicePopupButtonLabel: "Close",
      devicePopupPart1:
        "A small handheld car breathalyzer device that measures the amount of alcohol in the user’s breath. Installing one is a common requirement following a drunk driving offense (DUI, DWI, DUI, OWI, or OVI).",
      devicePopupPart2:
        "A small, portable handheld breathalyzer device that measures the amount of alcohol in the user’s breath. Commonly issued to monitor a user while at home.",
      devicePopupPart3:
        "A solution that helps control your speed by maintaining a fixed top speed limit to ensure you are practicing safe driving habits.",
      IDStateLabel: "ID issuing state",
      IDNumberLabel: "Identification Number",
      IdExpDateLabel: "Expiration Date",
      IdExpDateRequired: "Expiration Date is Required",
      IDInfoTitle: "State ID Information",
      vehInfoTitle: "Vehicle Information",
      multiVehicleNew: "New Vehicle",
      vehYearLabel: "Vehicle Year",
      vehYearPlaceholder: "Select a Year",
      vehYearRequired: "Vehicle Year is required.",
      vehMakeLabel: "Vehicle Make",
      vehMakePlaceholder: "Select a Make",
      vehMakeRequired: "Vehicle Make is required.",
      vehModelLabel: "Vehicle Model",
      vehModelPlaceholder: "Select a Model",
      vehModelRequired: "Vehicle Model is required.",
      VINYearLabel: "Year: ",
      VINMakeLabel: "\nMake: ",
      VINModelLabel: "\nModel: ",
      licPlateIssue:
        "Hmm, something went wrong in my wiring, please input your vehicle's license plate number and issuing state one more time for me! If you don't have it click the red skip button.",
      licPlateLabel: "License Plate Number",
      licPlateRequired: "License Plate number is required.",
      vehSaveError: "Vehicle not saved",
      adminButtonLabel: "Administrative",
      courtButtonLabel: "Court Order",
      voluntaryButtonLabel: "Voluntary",
      preTrialButtonLabel: "Pre-Trial",
      probationButtonLabel: "Probation",
      VINInfoLinkPart1: "Click ",
      VINInfoLinkPart2:
        " for some quick information about your Vehicle Identification Number (VIN).",
      VINInfoLink: "here",
      ProgTypeInfoLinkPart2: " for some quick information about Program Types.",
      programTypeIssue:
        "Hmm, something went wrong in my wiring, please select your program type one more time for me!",
      ProgTypeInfoTitle: "Program Type Information",
      DeviceLengthQuestion: "How long will you need your device?",
      DeviceLengthMonths: "Months",
      DeviceLengthError: "You must choose a number between 3 and 24",
      AdminDescription:
        "This type of program is typically assigned by the Motor Vehicle Administration.",
      CourtOrderDescription:
        "The court has ordered you to have a device installed.",
      VoluntaryDescription:
        "Volunteering to have a device installed is a great way to protect yourself and others.",
      PreTrialDescription:
        "This type of program typically means you may not have gone to court or been sentenced yet.",
      ProbationDescription:
        "The court has ordered you to have a device installed because you have been sentenced in 1 or more previous cases.",
      closePopUp: "Close",
      lossProtectionQuestion:
        "Would you like to include a loss protection plan for your device?",
      lossProtectionInfoLinkPart2:
        " for some quick information about the Loss Protection Plan.",
      lossProtectionInfoTitle: "Loss Protection Plan Information",
      lossProtectionInfoPart1: [
        "", //leave here because of the Spanish translation and how the phare is constructed for it.
        " monitoring devices aren't cheap and we wouldn't want to see you get stuck with the bill if something should happen. The ",
        " Loss Protection Plan avoids this necessary risk of not having protection against the occasionally mishap, we strongly encourage your to protect your device!",
      ],
      lossProtection: "Loss Protection",
      noProtection: "No Protection",
      lossProtectionIssue:
        "Hmm, something went wrong in my wiring, please select your loss protection one more time for me!",
      vehicleSwap: "Vehicle Swap",
      vehicleSwapMessage:
        "Please contact us directly to reschedule your Vehicle Swap Appointment.",
      noAvailableTimes: "No available times",
      appointmentNotSaved: "Appointment not saved",
    },
    payments: {
      accountInfo: "Account Information",
      makePayment: "Make a Payment",
      paymentMethods: "Payment Methods",
      accountBalance: "Account Balance",
      accountHistory: "Account History",
      makePaymentButton: "Make A Payment",
      acctBalMessage1: "Please Wait",
      acctBalMessage2: "Balance available shortly...",
      dateHeader: "Date",
      descHeader: "Description",
      amountHeader: "Amount",
      invoiceHeader: "Invoice",
      balanceHeader: "Balance",
      transHistory: "Transaction History",
      newCardButton: "Add New Card",
      noAutoPayMessage: "Currently your account isn't set up for auto pay.",
      cardRejectedMessage:
        "This card has been rejected. Please edit or delete.",
      autoPay: "Auto Pay",
      autoPayMessage:
        "By checking this box, you are authorizing us to charge this card pursuant to the Terms and Conditions of your Program Service Agreement.",
      billingCycleLabel: "Auto Pay Billing Cycle",
      weekly: "Weekly",
      biweekly: "BiWeekly",
      monthly: "Monthly",
      editButton: "Edit",
      deleteButton: "Delete",
      deleteMessage: "Are you sure you want to delete this payment method?",
      acceptedPayMethods: "Accepted Payment Methods",
      paymentMethod: "Payment Method",
      redoMessage: "You will need to revalidate card information.",
      zipCode: "Zip Code",
      cardNumber: "Card Number",
      expDate: "Expiration Date",
      autoPaySignUpMessage:
        "By submitting your credit or debit card information on this page and checking this box, you are authorizing us to charge this card pursuant to the Terms and Conditions of your Program Service Agreement.",
      autoPayEnroll: "Enroll in Auto Pay",
      zipCodeError: "Invalid Zip Code, please correct.",
      cardNumberError: "Invalid Card Number, please retry.",
      cvv2Error: "Invalid CVV2, please correct.",
      expDateError: "Invalid Expiration Date, please correct.",
      verifyButton: "Verify",
      confirmation: "Confirmation",
      selectPaymentMethod: "Please Select Payment Method",
      selectPaymentAmount: "Please Select Payment Amount",
      otherAmount: "Other Amount",
      submitButton: "Submit",
      confirmMessagePart1: "You have selected to make a \n payment on: \n",
      confirmMessagePart2: "\n in the amount of: \n $ ",
      confirmAlert:
        "Refreshing the page during processing can cause balance inaccuracy and duplicate payments.",
      invoiceDownloading: "Invoice downloading...",
      invoiceDownloaded: "Invoice downloaded",
      invoiceDownloadFailed: "Invoice failed to load",
      noCCPaymentOption:
        "Credit card payment option is not set up for your location.",
      noCCOnFile: "No active cards on file.",
      ccDeleted: "Payment method deleted.",
      paymentReceived: "Payment received.",
      paymentFailed: "Payment failed.",
      ccVerificationError: "There was a problem verifying this payment method.",
      ccNotSupported:
        "Your current location does not support online credit card payments. Please call us at (800) 634-3077",
      ccPaidToDateInPastPart1:
        "To enable Auto Pay we need you to pay your current account balance, click ",
      ccPaidToDateInPastPart2:
        "to make your payment. If you have any questions or need assistance, please feel free to ",
      addAPaymentMethod:
        "Please add a payment method to make a payment online.",
      add: "Add",
      have2devices:
        "You currently have 2 devices for this vehicle, one needs to be returned to process a payment. Need Assistance?",
      goBack: "Back",
      information: "Information",
      appointmentType: "Appointment Type",
      appointmentTypeDescription: "Appointment Type Description",
      calibration: "Calibration",
      violationReset: "Violation Reset",
      select: "Select",
      vehicle: "Vehicle",
      days: "Days",
      shippingAddress: "Shipping Address",
      verify: "VERIFY",
      shipping: "Shipping",
      standardShipping: "Standard Shipping",
      expedientShipping: "Expedient Shipping",
      cancel: "Cancel",
      paymentSummary: "Payment Summary",
      makePaymentInPayment: "MAKE PAYMENT",
      thankyouPayment: "Thank You for your Payment.",
      failurePayment: "Payment Failure, please try again.",
      contactMessage:
        "When the total balance due is below $0 our online payment option is not available. Please contact our Customer Support team to assist you with this payment, (800) 634-3077.",
      earlyServiceFee:
        "Early Service Fee of $10 will be applied to this payment",
      appointmentDefinition: "Appointment Definition",
      apptDescCalibration:
        "If only your service light has just come on (comes on 10 days before you are due) it's time to make another 30 or 60 day payment.",
      apptDescLockOut1:
        "If your service and lockout lights have come on at the same time you are in early recall and your device needs to be reset.",
      apptDescLockOut2: "Note: ",
      apptDescLockOut3:
        "Your device will lock out 5 days after these lights started flashing.",
      quantity: "Quantity",
      item: "Item",
      unitPrice: "Unit Price",
      amount: "Amount",
      freeShips: "Free, ships in 2-3 business days",
      nextShips: [
        "$25.00, Device will be ",
        "shipped",
        " the following business day.",
      ],
      boxOverride: "PO Box Override",
      calculatingPayment: "Calculating Payment, Please Do NOT Refresh",
      processingPayment: "Processing Payment, Please Do NOT Refresh",
      taxableAmount: "Taxable Amount",
      tax: "Tax",
      nonTaxableAmount: "Non-Taxable Amount",
      totalNewCharges: "Total New Charges",
      priorAccountBalance: "Prior Account Balance",
      totalAmountDueNow: "Total Amount Due Now",
      due: "Due",
      now: "Now",
    },
    documents: {
      ToDO: "To Do",
      Completed: "Completed",
      formHeader: "Form",
      infoHeader: "Info",
      actionHeader: "Action",
      viewHeader: "View",
      review: "Review",
      upload: "Upload",
      template: "Form",
      warning:
        "The Sign and Submit button will become active when you reach the last page of the document.",
      signAndSubmit: "Sign and Submit",
      signAndSubmitSM: "Sign and\nSubmit",
      reviewed: "Reviewed",
      warningNonSignature:
        "The Reviewed button will become active when you reach the last page of the document.",
      signatureTitle: "Adopt Your Signature",
      adoptSignature: "Adopt Signature",
      cancel: "Cancel",
      legalName: "Legal First and Last Name",
      update: "Update",
      agreementPartI:
        "By selecting a signature and clicking the 'Adopt Signature' button you are agreeing to and signing the ",
      esa: "Electronic Signature Agreement.",
      agreementPartII:
        " Please take the time to read this document prior to continuing.",
      signature: "Signature",
      initials: "Initials",
      userSignatureSaveSuccess: "User signature saved",
      saveCompletedReportSuccess: "Completed report saved",
      documentDownloading: "Downloading document",
      documentDownloadFailed: "Failed to download document",
      documentDownloadSuccess: "Document downloaded",
      documentUploadSuccess: "Document uploaded",
      documentUploadFailed: "Document upload failed",
      documentUploadDataError: "Wrong data file",
      documentUploadErrorUploadType: "Missing Upload Type",
      documentUploadErrorFileType: "File Type not Supported",
      documentUploadErrorFileSize: "Max File Size of 10MB Exceeded",
      loadDocumentFailed: "Document load failed",
      instructions: "Instructions",
      photoInstructions:
        "When taking the picture please ensure the document is as centered as possbile. When you're ready click the button below to activate your camera, you may need to allow us this access (popup should appear).",
      computerCamInfo:
        "Note: Many built in laptop webcams may not yield a high enough quality picture for this upload process.",
      fileInstructions:
        "When taking the picture please ensure the document is as centered as possbile. Then click the upload button and pick your image. Accepted formats: .png, .jpg, .jpeg, .heic, .pdf",
      retake: "Retake",
      photoUpload: "Take Photo",
      fileUpload: "Upload File",
      chooseFile: "Choose File",
      newFile: "Choose Another File",
      goBack: "Back",
      badPhotoFile: "Bad Photo File",
      uploadNow: "Upload Now",
      documentExample: "Example",
      signDocumentFail: "Sign document failed",
      save: "Save",
      saving: "Saving",
      saved: "Saved",
      saveError: "Error saving",
      formNotValid: "Please fill all required form fields.",
      invalidSSN: "Please enter valid 4 digit SSN.",
      appointment: "Appt",
      declineModalHeader: "Information",
      declineModalBody:
        "Signing documents electronically allows for a faster installation saving your time. Are you sure you don’t want to sign electronically?",
      showHelpText: "Questions? Click ",
      showHelpLinkText: "Here",
      signButton: "Sign",
      declineButton: "Decline",
      noDocuments: "No Documents Available",
      permissionDenied: "Please allow access to your camera.",
      form: "Form",
      vehicle: "Vehicle",
      viewExample:
        "The example will open in a new tab momentarily. You may need to allow pop-ups for this site.",
      bookingInstallation:
        "Thank you for booking your installation, now let’s talk about the next steps to your success!",
      modalMessage1:
        "You will receive a text message from your {{brand}} White Glove specialist who can talk to you about your installation, discounts, and answer any other questions you may have. You can text or call us using that dedicated number.",
      modalMessage2:
        "Upon closing this pop up we will redirect you to the Documents section to get your quick to review, easy to sign pre-installation paperwork wrapped up and have you enter any required compliance information.",
      whiteGloveMessage:
        "Our White Glove Team is dedicated to your success, guiding you through the Pre-Installation process and they’re ready to help, get in touch now.",
      midName: "Middle Name",
      minLength: "Minimum Length is 2",
      minLengthThree: "Minimum Length is 2",
      sex: "Sex",
      dlNum: "DL Number",
      dlNumminLength: "Minimum Length is 4",
      caseNum: "Case Number",
      mslNum: "MSL Number",
      arrestDtRequired: "Arrest Date Required",
      arrestDt: "Arrest Date",
      convictedDtRequired: "Conviction Date Required",
      convictedDt: "Convicted Date",
      vehOwner: "Owner Name",
      insuranceCompany: "Insurance Company",
      titleNumber: "Title Number",
      odometer: "Odometer",
      color: "Color",
      selectColor: "Select a Color",
      licPlate: "License Plate",
      vinLong: "Vehicle Identification Number (VIN)",
      vinValid: "VIN must be 16 or 17 characters in length.",
      missingInfoInformation:
        "Information required from you to ensure proper compliance for reporting your program.",
      missingInfoExtended: "Missing Required Information",
      documentErrorMessage: "Error saving report, Please try again later",
      odometerRequired: "Odometer is required",
      odometerNumeric: "Odometer must be numeric",
      odometerMaxLength: "Odometer value must be 6 characters or fewer",
      missingInformation: "Missing Information",
    },
    resources: {
      generalInfoHeader: "General Information",
      installCard: "Installation Information",
      installDesc:
        "Know what to expect at your interlock installation appointment.",
      installURL: "https://www.youtube.com/watch?v=dfMV64_RGx8",
      dosAndDontsCard: "Test Do's and Dont's",
      dosAndDontsDesc:
        "Understand the Do's and Don'ts of taking a alcohol breath test on your device.",
      dosAndDontsURL: "https://www.youtube.com/watch?v=fLVWcTyOi9A&t=10s",
      foodWarningCard: "Food Warning",
      foodWarningDesc:
        "There are some foods to avoid before taking a test, watch and learn how they can affect you.",
      foodWarningURL: "https://www.youtube.com/watch?v=VZg9lDAMLfU",
      deviceInfoHeader: "Device Information",
      L250TrainingCard: "L250 Training",
      L250TrainingDesc:
        "Learn about, how to use, and care for your L250 Ignition Interlock Device with this video training.",
      L250TrainingURL: "https://www.youtube.com/watch?v=SU_RHzfxkRc&t=5s",
      L250WarmUpCard: "L250 Warm Up Times",
      L250WarmUpDesc:
        "Learn about how to set up warm up times for your L250 Interlock to save time in cold weather.",
      L250WarmUpURL: "https://www.youtube.com/watch?v=mj4H6D5SYmw",
      FC100TrainingCard: "FC100 Training",
      FC100TrainingDesc:
        "Learn about, how to use, and care for your FC100 Ignition Interlock Device with this video training.",
      FC100TrainingURL: "https://www.youtube.com/watch?v=biubuR6AJU8",
      FI100TrainingCard: "FI100 Training",
      FI100TrainingDesc:
        "Learn about, how to use, and care for your FI100 Ignition Interlock Device with this video training.",
      FI100TrainingURL: "https://www.youtube.com/watch?v=biubuR6AJU8",
      PAMTrainingCard: "PAM Training",
      PAMTrainingDesc:
        "Learn about, how to use, and care for your Portable Alcohol Monitor with this video training.",
      PAMTrainingURL: "https://www.youtube.com/watch?v=KVQUId66ZOs",
      ISATrainingCard: "Intelligent Speed Assistance",
      ISATrainingDesc:
        "Get to know your ISA and how it works with this informative video",
      ISATrainingURL: "https://www.youtube.com/watch?v=7iyUQl_OQqk&t=45s",
    },
    help: {
      contactUs: "Contact Us",
      contactUsMessage:
        ", let's get you assistance from our 24/7 expert support team!",
      contactUsCallClick: "Call or Click",
      emailUs: "Email Us",
      emailUsMessage: "Have you found an issue or error within our site?",
      chatTitle: "Help",
      chatMessage:
        "Need help with your account and can't find it in the the portal?",
      chatSubMessage: "Chat with an agent.",
      chatButton: "Chat now",
      callUsButton: "Call Us ",
      lockout:
        "This appointment cannot be rescheduled from this portal, please contact us so we can help you with this request.",
      errorMessage:
        "Well, this is awkward and very embarrassing. It looks like my wires got crossed somewhere along the way.",
      tryAgain: "Try Again",
    },
    securepay: {
      title: "Secure Pay",
      unauthorized: "Unauthorized",
      securepayLinkdesc: [
        "The Secure Pay link has either expired or isn't available for use. If you believe you've reached this message in error",
        "please feel free to contact us.",
      ],
      sessionTimer: "Session Timer: ",
      client: "Client: ",
      amountDue: "Amount Due: ",
      makePayment: "MAKE PAYMENT",
      agree: "Agree",
      paymentMethod: "Payment Method",
      payMessage:
        "By submitting your credit or debit card information on this page and checking this box, you are authorizing us to charge this card pursuant to the LifeSafer Terms of Use Policy.",
      paymentFailure: "Payment Failure, please try again.",
      securePaymentSaveFailure: "Secure Payment Save Failure: ",
      errorWithCreditCard: "Error with Credit Card Payment Save, ID: ",
      thankYou: "Thank You!",
      thankYouAfterPayment: [
        "The payment has been processed successfully for ",
        "You should receive a text message with your receipt shortly if not please feel free to contact us at (800) 634-3077",
      ],
      successPayment:
        "Payment Success. You should receive a text message with your receipt shortly.",
    },
    quote: {
      pricingTitle: " Your {{deviceType}} Pricing",
      biWeekly: "{{ pricingDuration }} rate",
      oneTimeInstallation: "One-time Installation Cost",
      infoDescription1:
        "*{{ pricingDuration }} cost may vary. The state you reside in impacts your calibration and reporting cost frequency. For more information, read the full <u><click>{{deviceType}}</click>.</u>",
      infoDescriptionWeb1:
        "*{{ pricingDuration }} cost may vary. The state you reside in impacts your calibration and reporting cost frequency. For more information, read the full {{deviceType}}.",
      meetSpecialist: "Meet Your {{convictionState}} Specialist",
      specialistDescription:
        "Hi there, I'm <b>{{name}}</b>, your dedicated {{state}} Specialist. I've been helping {{helping}} navigate the {{deviceType}} process for over {{serviceYears}} years, so you're in good hands. If you have any questions, give me a call at <u> {{specialistNumber}} </u>, I'm here to make things simple and stress-free.",
      pricing: "Pricing",
      scheduling: "SCHEDULING",
      pricingInformationTitle: "{{deviceType}} Pricing Information",
      installation: "Installation",
      stateReporting: "{{stateInitials}} State Reporting",
      biWeeklyBreakdown: "{{ pricingDuration }} Breakdown",
      biWeeklyLease: "{{ pricingDuration }} lease with device protection",
      transparentPricing: "Transparent Pricing",
      transparentPricingDescription:
        "{{deviceType}} pricing is determined by your state requirements and the vehicle you'll install in. And because we believe in transparent pricing, if you get an equivalent quote elsewhere, we'll match the price.",
      yourInformation: "Your information",
      clientId: "Client ID",
      quoteDetails: "Quote details",
      device: "Device",
      leaseDuration: "Lease Duration",
      whyLifeSafer: "Why LifeSafer?",
      whyTitle1: "<b>State Certified & Court Approved:</b> ",
      whyDescription1:
        " Fully compliant with all state {{deviceType}} program requirements.",
      whyDescription2:
        " Friendly technicians and specialists who guide you through every step of your program.",
      whyDescription3:
        " LifeSafer has helped hundreds of thousands of {{helper}} regain their independence safely.",

      whyTitle2: "<b>Local Experts Who Care:</b> ",
      whyTitle3: "<b>Trusted for Over 30 Years:</b> ",

      faqTitle1: "Do I have to pay for everything upfront?",
      faqDescription1:
        " No. You’ll typically pay for installation on the day of your appointment. Your lease is billed regularly (bi-weekly or monthly, depending on your payment frequency) for as long as you’re required to have the device.",

      faqTitle2: "Are there any hidden fees?",
      faqDescription2:
        "While costs differ by state and monitoring official, we do our best to present costs as honestly as we can. You may see charges related to damage to the device or if your state requires extra services like camera-equipped units.",

      faqTitle3: "Can I prepay or set up autopay?",
      faqDescription3:
        "Yes, you can enroll in autopay to make billing easier (and sometimes save).",

      faqTitle4: "When do I start being billed?",
      faqDescription4:
        "Billing begins once your device is installed and activated",

      faqTitle5: "Does my pricing expire?",
      faqDescription5:
        "Yes. Ignition interlock pricing is valid for 3 days. After that, rates or promotions may change.",

      faqTitle6: "How difficult is the device to use?",
      faqDescription6:
        "Not difficult at all. The LifeSafer IID is designed to be simple and reliable. Once installed, you’ll get a quick walkthrough on how it works. It only takes a few seconds to provide a breath sample, and the device gives you on-screen prompts to guide you every step of the way. Most drivers find they’re comfortable using it after just a few tries.",

      faqTitle7: "What happens if I need help with something on the weekends?",
      faqDescription7:
        "You’re never on your own. LifeSafer’s customer support is available 24/7, including weekends and holidays. If you have a question or issue, you can reach our team by phone for immediate help or visit our online resources for troubleshooting tips and how-to guides.",

      faqTitle8:
        "What happens if I don’t need the device for the full 6 months, 12 months, 24 months, etc.?  Am I locked into paying the full term?",
      faqDescription8:
        "No long-term lock-ins. Your IID lease length is based on your state requirements, but you only pay for the time you actually need the device. If your program ends early, we’ll help you schedule removal right away and stop future billing once it’s returned.",

      faqTitle9:
        "Are you going to permanently damage part of my car to install this device?",
      faqDescription9:
        "Not at all. The installation is completely reversible and won’t cause permanent damage. Certified technicians use professional methods to connect the IID safely to your vehicle’s ignition system. When your program is over, they’ll remove the device and restore your car to its original condition.",

      faqTitle10: "How often does the device need to be calibrated?",
      faqDescription10:
        "Calibration is quick and only required once every 30 to 90 days, depending on your state’s rules. During calibration, a technician checks the device to make sure it’s accurate and working properly. Appointments usually take less than 15 minutes, and you’ll get reminders so you never miss one.",

      faqTitle11: "What are lockout costs?",
      faqDescription11:
        "A lockout happens when the device can’t be used until it’s serviced, usually because of missed calibrations, low power, or certain violations. If this happens, there may be a small service fee to reset or unlock the device. Our team will help you get back on the road quickly if a lockout occurs.",

      faqTitle12: "Which vehicle do I need to install the IID in?",
      faqDescription12:
        "You’ll need to install the IID in the vehicle you drive most often, or any vehicle you’ll be driving during your program period. If you have more than one vehicle, check with your monitoring authority to confirm whether all vehicles require installation. Our team can also help you verify what is needed based on your state’s rules.",

      faqTitle13: "Does my car need to be registered and insured?",
      faqDescription13:
        "Yes. Your vehicle must be legally registered and insured before we can install the ignition interlock device. This ensures that the installation is compliant with state regulations and that you’re protected while driving during your program. If your registration or insurance is pending, our team can help you understand what documentation you’ll need to get started.",

      faqTitle14: "What if I don’t have a license?",
      faqDescription14:
        "That’s okay. Many people start the IID process before their license is reinstated. You can schedule your installation now so you’re ready as soon as the state or court gives you permission to drive again. We’ll guide you through what’s required to stay in compliance while your license is being reinstated.",

      faqTitle15: "What if I only have a passport?",
      faqDescription15:
        "You can still begin the process. A passport can serve as your primary ID when scheduling installation, but you’ll also need to provide any state or court documentation related to your interlock requirement. Our team can walk you through exactly what forms of ID and paperwork are accepted in your state.",
      info: "Info",
      faqPamTitle1: "Do I have to pay for everything upfront?",
      faqPamDescription1:
        "No. Portable Alcohol Monitoring doesn’t require a large installation fee like an IID. You’ll typically pay a low daily or monthly monitoring rate, and billing continues for as long as your monitoring program requires the device.",

      faqPamTitle2: "Are there any hidden fees?",
      faqPamDescription2:
        "We do our best to keep pricing straightforward. Depending on your state or monitoring authority, you may see additional charges for things like reporting requirements or lost or damaged equipment. We’ll always explain your costs clearly so there are no surprises.",

      faqPamTitle3: "Can I prepay or set up autopay?",
      faqPamDescription3:
        "Yes. You can sign up for autopay or prepay your monitoring fees to make billing easier and avoid missed payments.",

      faqPamTitle4: "When does billing start?",
      faqPamDescription4:
        "Billing begins once your Portable Alcohol Monitor is assigned and your monitoring program begins.",

      faqPamTitle5: "Does my pricing expire?",
      faqPamDescription5:
        "Pricing can change over time, so we encourage you to confirm your rate when enrolling. Portable monitoring programs are typically priced affordably, often only a few dollars per day.",

      faqPamTitle6: "How difficult is the device to use?",
      faqPamDescription6:
        "Not difficult at all. The Portable Alcohol Monitor is designed to be simple and straightforward. The device will alert you when a test is required and guide you through each step with on-screen prompts. Most people get comfortable using it after just a few tests.",

      faqPamTitle7: "What happens if I need help on weekends?",
      faqPamDescription7:
        "You’re never on your own. Our customer support team is available to help you throughout your monitoring period, and we also offer online resources and troubleshooting guides you can access anytime.",

      faqPamTitle8: "Is the device invasive or permanent?",
      faqPamDescription8:
        "Not at all. The Portable Alcohol Monitor isn’t installed in your vehicle and won’t affect your car or home. It’s lightweight, handheld, and designed to fit easily into your daily routine.",

      faqPamTitle9: "How often does the device need to be calibrated?",
      faqPamDescription9:
        "Portable monitoring devices require periodic calibrations to ensure accuracy. The frequency is determined by the monitoring official and program guidelines, typically every 30 to 90 days. Your responsibilities include taking tests as prompted, keeping the device charged, and attending scheduled calibration appointments.",

      faqPamTitle10: "Where do I use the Portable Alcohol Monitor?",
      faqPamDescription10:
        "You can use it anywhere your program requires—at home, at work, or on the go. It’s designed for flexibility, allowing you to complete tests from almost any location.",

      faqPamTitle11: "Do I need a vehicle, license, or insurance?",
      faqPamDescription11:
        "No. Portable alcohol monitoring is not tied to your vehicle, so you don’t need a car, insurance, or a valid license. You only need to follow the testing schedule set by your monitoring authority.",

      faqPamTitle12: "What if I don’t have a license?",
      faqPamDescription12:
        "That’s completely fine. Many clients begin portable alcohol monitoring before regaining driving privileges. We’ll help you get started so you remain compliant with your requirements.",

      faqPamTitle13: "What if I only have a passport?",
      faqPamDescription13:
        "You can still start the process. A passport can be used as your primary ID when enrolling, as long as you also bring any state or court documents related to your monitoring requirement. Our team can help confirm what’s needed based on your state.",

      faqIsaTitle1:
        "What is the upfront cost when enrolling in an ISA program?",
      faqIsaDescription1:
        "No. You don’t have to pay a large upfront cost to begin your ISA program. You’ll choose a monthly or annual monitoring plan, and billing will begin once your device is installed and activated.",

      faqIsaTitle2: "Are there any hidden fees?",
      faqIsaDescription2:
        "We value transparency. Your plan will outline all standard costs up front. Additional charges may apply for optional upgrades, damaged equipment, or service requests required by your monitoring authority. We’ll walk you through your total expected cost before you begin.",

      faqIsaTitle3: "Can I prepay or set up autopay?",
      faqIsaDescription3:
        "Yes. You can prepay or enroll in autopay to avoid missed payments and stay compliant with your monitoring requirements.",

      faqIsaTitle4: "When does billing start?",
      faqIsaDescription4:
        "Billing starts once your ISA device is professionally installed and activated in your vehicle.",

      faqIsaTitle5: "Does my pricing expire?",
      faqIsaDescription5:
        "Your rate will stay the same for the length of your selected plan. If your monitoring period is extended or changed, pricing may adjust based on the current rates at that time.",

      faqIsaTitle6: "Are service or support fees included?",
      faqIsaDescription6:
        "Standard customer support is always included. If your monitoring authority requires additional reporting or device services, we’ll help explain those fees.",

      faqIsaTitle7: "Is it difficult to operate an ISA device?",
      faqIsaDescription7:
        "No. ISA is designed to be simple, reliable, and easy to use. The optional display changes color automatically when speed limits change.",

      faqIsaTitle8:
        "What happens if I need help outside normal business hours?",
      faqIsaDescription8:
        "LifeSafer support is available 24/7, 365 days a year.",

      faqIsaTitle9: "Will the device permanently alter my vehicle?",
      faqIsaDescription9:
        "No. Once your monitoring requirement is complete, the device can be removed and your vehicle will be restored to its original condition.",

      faqIsaTitle10:
        "Does the device require calibration or regular servicing?",
      faqIsaDescription10:
        "ISA devices do not require routine calibration. They rely on advanced GPS satellite technology and onboard maps to operate accurately.",

      faqIsaTitle11: "Does ISA slow down or stop my vehicle?",
      faqIsaDescription11:
        "ISA will not apply the brakes or shut off your engine. It only limits accelerator pedal response once the programmed speed limit is reached.",

      faqIsaTitle12: "Can I turn ISA off?",
      faqIsaDescription12:
        "There is no off switch. Depending on your program, a temporary override may be available for a limited time.",

      faqIsaTitle13: "Which vehicle should the ISA device be installed in?",
      faqIsaDescription13:
        "The device must be installed in the vehicle you drive regularly during your monitoring period. If you share vehicles or have more than one, check your program requirements.",

      faqIsaTitle14: "Does my vehicle need to be registered and insured?",
      faqIsaDescription14:
        "Yes. Your vehicle must be fully registered and insured before installation.",

      faqIsaTitle15: "What if I don’t currently have a valid license?",
      faqIsaDescription15:
        "In many states, you can install an ISA device before your license is reinstated. This may help speed up the reinstatement process.",

      faqIsaTitle16: "Can I use a passport or other ID?",
      faqIsaDescription16:
        "Yes. A passport or other government-issued ID can be used when enrolling, along with any required court or state documentation.",

      faqIsaTitle17: "What is Intelligent Speed Assistance (ISA)?",
      faqIsaDescription17:
        "Intelligent Speed Assistance is a certified device installed in your vehicle to help prevent speeding.",

      faqIsaTitle18: "How does ISA work?",
      faqIsaDescription18:
        "The device monitors your vehicle speed and the current road speed limit. Once the programmed limit is reached, it prevents further acceleration.",

      faqIsaTitle19:
        "Will my monitoring authority receive access to my driving data?",
      faqIsaDescription19:
        "If required by your program, certain speed-related compliance reports may be shared. We’ll clearly explain what data is provided.",

      faqIsaTitle20: "Can I switch vehicles during my program?",
      faqIsaDescription20:
        "Yes. The device must be professionally transferred to the new vehicle. Reinstallation fees may apply, and notification is required to stay compliant.",

      faqIsaTitle21: "How long do I have to keep the ISA device installed?",
      faqIsaDescription21:
        "The required installation period depends on your state laws and your specific court, DMV, or program requirements.",

      faqIsaTitle22: "What if my device stops working?",
      faqIsaDescription22:
        "Contact us immediately. We’ll help troubleshoot the issue or schedule service if needed.",

      faqIsaTitle23:
        "What if a speed limit sign doesn’t match my device’s display?",
      faqIsaDescription23:
        "ISA uses frequently updated map data. If you notice an incorrect speed limit, contact us and we’ll submit a correction request.",
      quoteOverview: "Quote Overview",
      quoteValid: " quote valid through",
      quoteBreakdown: "Quote Breakdown",
      scheduleInstallation: "Schedule Your Installation Today",
      scheduleAppointment: "SCHEDULE MY APPOINTMENT",
      scheduleInfoDescription1:
        "Great news; your {{deviceType}} pricing is confirmed! Now it's time to schedule your appointment.",
      scheduleInfoDescription2:
        "Appointments fill up quickly, and times are limited.Secure your preferred day and time now to avoid delays.",
      NoQuoteDescription:
        "A State specialist is preparing your updated pricing and will be in touch shortly.",
      booked: "You’re booked!",
      confirmationSent: "Your confirmation will be sent out shortly.",
      at: "at",
      youWillBeGoing: "You’ll be going to",
      calendar: "Calendar",
      googleCalendar: "Google Calendar",
      appleCalendar: "Apple Calendar",
      outlookCalendar: "Outlook Calendar",
      createAccount: "Create Your LifeSafer Account",
      finalConfirmationDescription:
        "With a LifeSafer Account, you can easily view appointment details, sign documents, and manage payments, all in one convenient place. Create your account today and enjoy a faster, more streamlined experience.",
      addTo: "Add to",
      lossProtection: "Loss Protection Plan",
      homeAddress: "Home Address",
      transparentPricingSupport: "Transparent Pricing Support",
      fileUploadDescription:
        "We believe in transparent, fair pricing. If you receive an equivalent quote from another authorized provider, upload it below and we'll match it-so you always pay the right price with the reliability of LifeSafer's device and support.",
      chooseFileUpload: "Choose file to upload",
      uploadStatusDescription:
        "Thanks for submitting your quote. We're reviewing it to ensure it meets state requirements and matches the same level of service.",
      uploadStatusDescription2:
        "Your specialist will contact you shortly with updated pricing based on the reviewed quote.",
      lifesaferShop: "Your LifeSafer Shop",
      scheduleLike: "What day would you like to schedule?",
      installationTime: "Installation typically takes 60-90 minutes",
      availableAppointment: "Available appointment times",
      moreDate: "View More Dates",
      scheduleNow: "Schedule Now",
      recentExpireTitle: "Act Now-Your Pricing Has Expired!",
      recentExpireDescription:
        "Enter your ZIP code to reactivate your pricing and book your installation today. Schedule now and get",
      recentExpireDescription2: "$25 off your first bill!",
      installDevice: "to install an {{deviceType}} in your",
      installDevicePAM: "to install a {{deviceType}}.",
      scheduleYourAppointment: "Schedule Your Appointment",
      fewMoreItems: "A few more items",
      finalizeAppointments:
        "We just need 3 more items to finalize your appointment details.",
      pricingExpired:
        "Your Pricing Has Expired - Let's Get You an Updated Quote",
      reviewingQuote: "We're Reviewing Your Quote",
      reviewingQuoteDescription:
        "Your State Specialist is reviewing your pricing and will be in touch with you shortly. If you have any questions, please give us a call.",
      myAccountLogin: "My Account Login",
      installedScheduled: "Installation Scheduled",
      installedScheduledDescription:
        "Your installation is already scheduled! Need more information or want to confirm the details of your appointment? Log into the My Account Site.",
      stateIdDescription:
        "Properly reporting your program is one of our top priorities and it starts with accurate information.",
      haveAnId:
        "Don't have an ID right now? Select the state in which you will have an ID, enter your date of birth and click the next button.",
      createPassword: "Create a password",
      confirmFinalPassword: "Confirm password",
      password: "Password",
      createAccountBtn: "CREATE ACCOUNT",
      iCalFile: "iCal File",
      chooseState: "Choose state...",
      sessionExpired: "Session expired. Please login again.",
      oneTimeInstallationCredits: "One-time Installation Credits",
      total: "Total",
      creditDescription:
        "* Credits are applied to your {{ pricingDuration }} costs and are not applied to the One-time Installation costs paid directly to your service center. Do this in the light text color as done in the Quote overview",
    },
  },
};
